<template>
    <div>

        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row">
                <!-- <a class="navbar-brand ml-3">Cek Status Truk</a> -->
                <div class="col-md-9">
                    <input
                        class="form-control filterInput"
                        type="search"
                        placeholder="Masukkan Nomor Ekspedisi"
                        aria-label="Search"
                        style="font: normal normal normal 16px/25px Poppins;"
                        v-model="filter.search"
                    >
                </div>
                <div class="col-md-3 text-right">
                    <button
                        class="btn"
                        type="button"
                        style="background-color: #1B698E; color: white; padding: 0 50px; height: 100%; font-weight: bold; font: normal normal 600 14px/21px Poppins;"
                        @click="fetchUserEkspedisi()"
                    >CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <div class="innerBox">
            <div class="mb-4 row">
                <div class="col-md-5"></div>
                <!-- <div class="col-md-2 text-right">
                    <button
                        class="btn border-secondary rounded shadow w-100"
                        type="button"
                        style="background-color: #1B698E; color: white; padding: 0 50px; height: 100%; font-weight: bold; font: normal normal normal 12px/18px Poppins;"
                        @click="modal.upload = true"
                    >Tambah</button>
                </div> -->
                <div class="col-md-2">
                    <h3 
                        class="tableTitle text-left"
                        style="font: normal normal normal 16px/25px Poppins;"
                    >User Ekspedisi</h3>
                </div>
                <div class="col-md-5">
                    <div class="row">
                        <div class="col-md-4">
                            <button
                                class="btn rounded w-100"
                                type="button"
                                style="background-color: #CEEDF8; color: #343434; height: 100%; font-weight: bold; font: normal normal normal 12px/18px Poppins;"
                                @click="modal.tambah = true"
                            >Tambah User</button>
                        </div>
                        <div class="col-md-4">
                            <button
                                class="btn rounded w-100"
                                type="button"
                                style="background-color: #CEEDF8; color: #343434; height: 100%; font-weight: bold; font: normal normal normal 12px/18px Poppins;"
                                @click="modal.upload = true"
                            >Upload File</button>
                        </div>
                        <div class="col-md-4">
                            <button
                                class="btn rounded w-100"
                                type="button"
                                style="background-color: #CEEDF8; color: #343434; height: 100%; font-weight: bold; font: normal normal normal 12px/18px Poppins;"
                                @click="downloadUserEkspedisi"
                            >Download XLSX</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Table Start -->
            <table class="table ekspedisi-table">
                <thead>
                    <tr>
                        <th>Nama Ekspedisi</th>
                        <th>Nomor Ekspedisi - Username</th>
                        <th>Status</th>
                        <th>Last Updated</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody v-if="data.user_ekspedisi != null">
                    <template v-for="(userEkspedisi, index) in data.user_ekspedisi">
                        <tr>
                            <td>{{ userEkspedisi.ekspedisi_name }}</td>
                            <td>{{ userEkspedisi.ekspedisi }}</td>
                            <td>{{ userEkspedisi.status == 'ACTIVE' ? 'Aktif' : 'Inaktif' }}</td>
                            <td>{{ moment(userEkspedisi.updated_at).format("DD/MM/YY") }}</td>
                            <td style="display: flex; align-items: center; justify-content: center;">
                                <button class="btn shadow rounded" @click="openUserEkspedisiUpdate(userEkspedisi)">
                                    <i class="fas fa-pencil"></i>
                                </button>
                                <i
                                    class="fas fa-2x ml-3 fa-caret-right dropdown-button-table"
                                    :style="{'transform' : userEkspedisi.ekspedisi_detail == null ? '' : 'rotate(90deg)'}"
                                    style="cursor: pointer;"
                                    @click="fetchEkspedisiDetail(userEkspedisi.ekspedisi, index)"
                                ></i>
                            </td>
                        </tr>
                        <transition name="slide-fade">
                            <tr v-if="userEkspedisi.ekspedisi_detail != null">
                                <td colspan="5" style="text-align: left;">
                                    <div style="padding-left: 100px">
                                        <p class="font-weight-bold">Nomor Polisi</p>
                                        <p v-if="userEkspedisi.ekspedisi_detail.length == 0" style="margin-bottom: 5px">~ Empty ~</p>
                                        <p
                                            v-else
                                            style="margin-bottom: 5px"
                                            v-for="nopol in userEkspedisi.ekspedisi_detail"
                                        >{{ nopol.nopol }}</p>
                                    </div>
                                </td>
                            </tr>
                        </transition>
                    </template>
                    <tr v-if="config.maxPage == -1">
                      <td colspan="100%" v-observe-visibility="loadingSeen">
                        <h4 class="mt-2" style="text-align: center; width: 100%; margin: 0">
                          Loading...
                        </h4>
                      </td>
                    </tr>
                </tbody>
            </table>
            <!-- Table End -->

        </div>

        <!-- Modal Start -->
        <user-ekspedisi-update
            v-if="modal.details"
            :data="modal.data"
            @refreshTable="fetchUserEkspedisi()"
            @closeModal="modal.details = false; modal.data = null"
        ></user-ekspedisi-update>

        <DealerStatusUpload 
            v-if="modal.upload"
            @closeModal="modal.upload = false"
            @onFinish="fetchUserEkspedisi()"
        />

        <UserEkspedisiTambah 
            v-if="modal.tambah"
            :data="modal.data"
            @refreshTable="fetchUserEkspedisi()"
            @closeModal="modal.tambah = false; modal.data = null"
        />
        <!-- Modal End -->

        <!-- Modal Start -->
        <div style="position: relative;">
            <validasi-kedatangan-truck-detail
                v-if="modal.edit"
                :edit_data="modal.editData"
                api_get="/api/settings/get-ekspedisi-detail"
                @refreshData="fetchUserEkspedisi()"
                @closeModal="modal.edit = false;"
            ></validasi-kedatangan-truck-detail>
        </div>
        <!-- Modal End -->

    </div>
</template>

<script>
    import qs from 'qs'
    import moment from 'moment'
    import { ObserveVisibility } from "vue-observe-visibility";

    import userEkspedisiUpdate from './children/UserEkspedisiUpdate.vue'
    import DealerStatusUpload from './children/UserEkspedisiUpload.vue'
    import UserEkspedisiTambah from './children/UserEkspedisiTambah.vue'
    import validasiKedatanganTruckDetail from './children/UserEkspedisiDrop'

    export default {
        metaInfo : {
            title : 'Dealer Status'
        },
        data () {
            return {
                moment: moment,
                modal: {
                    details: null,
                    data : {
                        dealer_name: null,
                        dealer_code : null,
                    },
                    upload : false,
                    tambah : null
                },
                config : {
                    maxPage : -1,
                    currentlyFetching : false,
                    currentPage : 1,
                    limitPerPage : 15,
                },
                data : {
                    user_ekspedisi : null,
                },
                filter : {
                    search : null
                },
                // vue_universal_table : {
                //     fields : [
                //         {title:"Nama Ekspedisi", variable:"ekspedisi_name"},
                //         {title:"Nomor Ekspedisi - Username", variable:"ekspedisi"},
                //         {title:"Status", variable:"status"},
                //         {title:"Last Updated", variable:"updated_at"},
                //     ],
                //     buttons: [
                //         {
                //             title: 'viewDetails',
                //             class: 'fas fa-pen btn-outline-primary'
                //         },
                //         {
                //             title : "validasiDetail", 
                //             class : "fas fa-pen btn border border-secondary rounded shadow"
                //         },
                //     ],
                //     filter: {
                //         search : '',
                //     },
                //     update : 0,
                //     process_data : `
                //         for (var i in data) {
                //             data[i].dealer_code = data[i].dealer_code ? data[i].dealer_code : '-'
                //             data[i].dealer_name = data[i].dealer_name ? data[i].dealer_name : '-'
                //             data[i].location_status = data[i].location_status ? data[i].location_status : '-'
                //             data[i].updated_at = data[i].updated_at ? data[i].updated_at : '-'
                //         }
                //     `
                // },
            }
        },
        components: {
            userEkspedisiUpdate,
            DealerStatusUpload,
            UserEkspedisiTambah,
            validasiKedatanganTruckDetail,
        },
        directives: {
            ObserveVisibility
        },
        mounted () {
            this.fetchUserEkspedisi();
        },
        methods : {
            openUserEkspedisiTambah (data) {
                this.modal.data  = JSON.parse(data)
                this.modal.tambah = true;
            },
            openUserEkspedisiUpdate (data) {
                this.modal.data  = data
                this.modal.details = true;
            },
            downloadUserEkspedisi () {
                for (var i in this.filter) if (this.filter[i] == '') this.filter[i] = null

                this.$http.get(`/api/settings/get-ekspedisi?pagination=false&${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.exportExcel(resp.data.data, "Download User Ekspedisi");
                })
                .catch((err)=>{console.log(err)});
            },
            loadingSeen(isVisible, entry){
                if(isVisible &&
                this.config.maxPage == -1 &&
                !this.config.currentlyFetching) this.fetchUserEkspedisi(this.config.currentPage+1);
            },
            fetchUserEkspedisi (page) {
                //Init fetchPage to 1
                let fetchPage = 1;

                //If first time call or wants to reset table
                if (page == null) this.data.user_ekspedisi = null;

                //If more than the first call
                else fetchPage = page;

                this.config.currentlyFetching = true;
                this.$http.get(`/api/settings/get-ekspedisi?page=${fetchPage}&pagination=true&limit=${this.config.limitPerPage}&${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    let data = resp.data.data;
                    let meta = resp.data.meta;

                    //Declare ekspedisi_detail
                    for (var i in data) data[i]['ekspedisi_detail'] = null;

                    //If first page
                    if (this.data.user_ekspedisi == null) this.data.user_ekspedisi = data;

                    //If it is second page or more
                    else {
                        this.data.user_ekspedisi = this.data.user_ekspedisi.concat(data);
                        this.config.maxPage = data.length < this.config.limitPerPage ? 0 : -1;//-1 Continue Infinite Scroll, 0 Stop Infinite Scroll
                    }

                    //Set current page
                    this.config.currentPage = meta.currentPage;
                })
                .catch((err)=>{console.log(err)})
                .finally(()=>{
                    this.config.currentlyFetching = false;
                });
            },
            fetchEkspedisiDetail (ekspedisi_id, array_id) {
                //Close if already opened
                if (this.data.user_ekspedisi[array_id]['ekspedisi_detail'] != null) {
                    this.data.user_ekspedisi[array_id]['ekspedisi_detail'] = null;
                    return;
                }

                this.$http.get(`/api/settings/get-ekspedisi-detail?ekspedisi=${ekspedisi_id}`)
                .then((resp)=>{
                    //Set ekspedisi_detail
                    this.data.user_ekspedisi[array_id]['ekspedisi_detail'] = resp.data.data;
                })
                .catch((err)=>{console.log(err)});
            }
        }
    }
</script>

<style>
    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateY(-10px);
        opacity: 0;
    }
</style>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;

    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .dropdown-button-table {
        transition: transform .3s ease;
    }
</style>